import { AxiosResponse } from 'axios';
import { FBaseService, ResponseEnvelope, ResponseEnvelopeCollection, ExpandableFilter } from '@kasasa/fbase-components/lib'; 
import Navigation from '@/services/Navigation';

export default class NavigationService extends FBaseService {
	findAll(clientId: string, siteId: string): Promise<AxiosResponse<ResponseEnvelopeCollection<Navigation>>> {
		return this.apiClient.get(`/api/kcms-nav/${clientId}/site/${siteId}/nav`);
	}
	find(clientId: string, siteId: string, id: string, filter: ExpandableFilter): Promise<AxiosResponse<ResponseEnvelope<Navigation>>> {
		return this.apiClient.get(`/api/kcms-nav/${clientId}/site/${siteId}/nav/${id}`, { params: filter.getQuery() });
	}
	create(clientId: string, siteId: string, navigation: Navigation) {
		return this.apiClient.post(`/api/kcms-nav/${clientId}/site/${siteId}/nav`, navigation);
	}
	update(clientId: string, siteId: string, id: string, navigation: Navigation) {
		return this.apiClient.put(`/api/kcms-nav/${clientId}/site/${siteId}/nav/${id}`, navigation);
	}
	delete(clientId: string, siteId: string, id: string): Promise<AxiosResponse<ResponseEnvelope<unknown>>> {
		return this.apiClient.delete(`/api/kcms-nav/${clientId}/site/${siteId}/nav/${id}`);
	}
}
